import styled from 'styled-components'

export const Root = styled.div``

export const Body = styled.div`
  font-size: 1rem;

  @media (min-width: 768px) {
    font-size: 1.125rem;
  }

  * + * {
    margin-top: 1rem;
  }
`
